import { createSelector } from 'reselect';

import { ESteps } from '~/src/features/full-buy/types';
import { TState } from '~/src/store';

const selectStepName = createSelector([
    (state: TState) => state.fullBuy,
], ({ stepIndex, flow }): ESteps | undefined => {
    return flow?.steps[stepIndex] || undefined;
});

export default selectStepName;
